<div id="buffers" #bufferSlider></div>
<div id="play-progress"></div>
<div id="duration-bar">
  <input #currentSliderInput type="range" min="0" [step]="0.01" />
</div>
